export default "__VITE_ASSET__38SwzEtZ__"